import * as React from 'react';
import { useStartTimeTracking } from '../../../../hooks/timeTracking';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import Button from '../../../../../../components/button';
import './StartTimeTrackingButton.css';
import { WarningModal } from '../../../TimeTracking/components/WarningModal/WarningModal';
import { useCallback } from 'react';
import { useTimeTrackingRestriction } from '../../../../hooks/timeTrackingSettings';
import { toISODateOnly } from '../../../../../../utils/dateUtils';

const i18Path = 'dashboard.timeTracking';

const StartTimeTrackingButton: React.FC = () => {
  const t = useNamespacedTranslation(i18Path);
  const {
    getTimeTrackingRestrictedReason,
    showRestrictedWarningModal,
    setShowRestrictedWarningModal,
  } = useTimeTrackingRestriction();
  const { startTimeTracking, loading } = useStartTimeTracking();
  const restrictionReason = getTimeTrackingRestrictedReason(
    toISODateOnly(new Date()),
  );

  const handleClick = useCallback(() => {
    if (restrictionReason) {
      setShowRestrictedWarningModal(true);
    } else {
      startTimeTracking();
    }
  }, [startTimeTracking, restrictionReason, setShowRestrictedWarningModal]);

  return (
    <>
      <WarningModal
        visible={showRestrictedWarningModal}
        restrictionReason={restrictionReason}
        onClose={() => setShowRestrictedWarningModal(false)}
      />
      <Button
        size="sm"
        className="rounded-2 start-tracking-btn h4-regular text-nowrap"
        onClick={handleClick}
        isProcessing={loading}
        label={loading ? '' : t('startTracking')}
        data-testid="start-tracking-btn"
      />
    </>
  );
};

export default StartTimeTrackingButton;
